import React, { useState, useEffect } from 'react';
import {
  Routes,
  Route,
  useNavigate,
  Navigate,
  useLocation
} from 'react-router-dom';

import Editor from './editor';
import RTLEditor from './rtl-editor';

function Playground(props) {

  function renderEditor() {

    const routeProperties = {
      path: 'editor',
      element: <Editor />
    };

    return <Route {...routeProperties}></Route>;

  }

  function renderRTLEditor() {

    const routeProperties = {
      path: 'rtl-editor',
      element: <RTLEditor />
    };

    return <Route {...routeProperties}></Route>;

  }

  function renderRoutes() {

    return <Routes>
      {renderEditor()}
      {renderRTLEditor()}
    </Routes>;

  }

  function renderMain() {

    return <div id="playground-main">
      {renderRoutes()}
    </div>;

  }

  return renderMain();

}

export default Playground;